module.exports = __webpack_public_path__ + "78f74c07170b5aaec7c89a923f91df34.svg";